var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"dashboard"},[_c('count-to'),_c('div',{staticClass:"col"},[_c('div',{staticClass:"col-md-12 grid-margin"},[_c('div',{staticClass:"card card-statistics"},[_c('div',{staticClass:"card-col-container"},[_c('div',{staticClass:"card-col"},[_c('div',{staticClass:"card-body"},[_c('bookingBar')],1)])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }